import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  body: {
    background: 'white',
    paddingLeft: theme.spacing(4),
  },
}));

export default useStyles;
